export const Logo = ({ className = "", light = true }) => {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg width="34" height="34" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="1.5" y="1.5" width="45" height="45" rx="8" stroke="#D4AF37" strokeWidth="1.5" />
        <path d="M13 34V15.5L24 10l11 5.5V34" stroke="#D4AF37" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M18 34V21h12v13" stroke="#D4AF37" strokeWidth="1.4" />
        <path d="M22 34v-6h4v6" stroke="#D4AF37" strokeWidth="1.4" />
        <path d="M18 21h12" stroke="#D4AF37" strokeWidth="1.4" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`font-display text-xl font-bold tracking-[0.18em] ${light ? "text-[#0B132B]" : "text-[#0B132B]"}`}>VERTEXHUB</span>
        <span className="font-mono-x text-[9px] tracking-[0.42em] text-gold">VENTURES</span>
      </span>
    </span>
  );
};
